import type { Ref } from "vue";
import type { StrapiImage, StrapiResponsiveImage } from "~/types/strapi";

export function useStrapiResponsiveImage(image: Ref<StrapiResponsiveImage>) {
  const { isDown } = useViewportObserver();
  const images = computed<{ isActive(): boolean; image?: StrapiImage }[]>(
    () => [
      {
        isActive: () => isDown(Breakpoint.md),
        image: image?.value?.mobile?.data?.attributes,
      },
      {
        isActive: () => isDown(Breakpoint.lg),
        image: image?.value.tablet?.data?.attributes,
      },
      {
        isActive: () => true,
        image: image?.value.desktop?.data?.attributes,
      },
    ],
  );

  const image4Render = computed<StrapiImage | undefined>(
    () => images.value.find((el) => el.isActive() && el.image)?.image,
  );

  return {
    image4Render,
  };
}
